export default {
  toastErrorTitle: {
    id: 'error_toast_intercom_not_available_title',
    defaultMessage: 'Hmm, we’re glitching',
  },
  toastErrorContent: {
    id: 'error_toast_intercom_not_available_content',
    defaultMessage: 'Something went wrong on our end. Please try again.',
  },
  toastUnauthorizedErrorTitle: {
    id: 'error_toast_intercom_unauthorized_title',
    defaultMessage: 'Hmm, you’re not logged in',
  },
  toastUnauthorizedErrorContent: {
    id: 'error_toast_intercom_unauthorized_content',
    defaultMessage: 'To continue, please log back in to your account.',
  },
}
